import dayjs from 'dayjs';

export const formatShortDate = (date: string, delimiter: string = '.') => {
  return dayjs(date).format(`DD${delimiter}MM`);
};
